import dayjs from 'dayjs';

export function getDateIsoString(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate beginnen bei 0
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

  return formattedDate;
}

export function getDateIsoStringPlus1Minute() {
  // const date = new Date(dayjs().add(1, 'minute').format('YYYY-MM-DD HH:mm'));
  const date = new Date();
  return getDateIsoString(date);
}
